













import { Component, Mixins } from "vue-property-decorator";
import { StandardTextDrawableObjectDrawerBase } from "./base";
import { FreeInputBehaviorPropertyEditableMixin } from "../../mixins";
import { default as TextAreaRectangleCoordinatableObjectEditor } from "./TextAreaRectangleCoordinatableObjectEditor.vue";

@Component({
  components: {
    TextAreaRectangleCoordinatableObjectEditor,
  },
})
export default class TagObjectDrawer extends Mixins(StandardTextDrawableObjectDrawerBase, FreeInputBehaviorPropertyEditableMixin) {
  get readonly(): boolean {
    return !this.freeInputBehavior.isEnable;
  }
}
